"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildQueryStringParams(params, addQuestionMarkSeparator) {
    if (typeof addQuestionMarkSeparator !== 'boolean') {
        addQuestionMarkSeparator = true;
    }
    var queryString = '';
    for (var property in params) {
        if (params.hasOwnProperty(property) && typeof property === 'string' && property) {
            queryString += property + "=" + params[property] + "&";
        }
    }
    if (queryString.length > 0) {
        queryString = (addQuestionMarkSeparator ? '?' : '') + queryString.substring(0, queryString.length - 1);
    }
    return queryString;
}
exports.buildQueryStringParams = buildQueryStringParams;
